export default __webpack_public_path__ + "static/media/lighter.b3fc95ff.png";